var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaktury = function SvgFaktury(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stxddasdasdasd23{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stxddasdasdasd23",
    d: "M23.3,10.5h-9c-0.4,0-0.7,0.3-0.7,0.7v12c0,0.4,0.3,0.7,0.7,0.7h9c0.4,0,0.7-0.3,0.7-0.7v-12 C24,10.8,23.7,10.5,23.3,10.5z M22.5,22.5H15V15h7.5V22.5z M22.5,13.5H15V12h7.5V13.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    className: "stxddasdasdasd23",
    width: 1.5,
    height: 1.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 16.5,
    className: "stxddasdasdasd23",
    width: 1.5,
    height: 1.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 19.5,
    className: "stxddasdasdasd23",
    width: 1.5,
    height: 1.5
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 19.5,
    className: "stxddasdasdasd23",
    width: 1.5,
    height: 1.5
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stxddasdasdasd23",
    d: "M18.8,0h-15C1.7,0,0,1.7,0,3.7v19.5c0,0.2,0.1,0.5,0.3,0.6C0.5,24,0.6,24,0.8,24C0.9,24,1,24,1,23.9l3.5-1.4 L8,23.9c0.2,0.1,0.4,0.1,0.6,0l3.7-1.5c0.4-0.2,0.6-0.6,0.4-1c-0.2-0.4-0.6-0.6-1-0.4l-3.5,1.4l-3.5-1.4c-0.2-0.1-0.4-0.1-0.6,0 l-2.7,1.1V3.7c0-1.2,1-2.2,2.2-2.2h12C15.3,2.1,15,2.9,15,3.7v4.5C15,8.7,15.3,9,15.8,9c0.4,0,0.7-0.3,0.7-0.7V7.5h5.2 c0.4,0,0.7-0.3,0.7-0.7v-3C22.5,1.7,20.8,0,18.8,0z M21,6h-4.5V3.7c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2V6z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stxddasdasdasd23",
    d: "M12.8,4.5h-9C3.3,4.5,3,4.8,3,5.2C3,5.7,3.3,6,3.8,6h9c0.4,0,0.7-0.3,0.7-0.7C13.5,4.8,13.2,4.5,12.8,4.5z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stxddasdasdasd23",
    d: "M9.8,10.5h-6c-0.4,0-0.7,0.3-0.7,0.7S3.3,12,3.8,12h6c0.4,0,0.7-0.3,0.7-0.7S10.2,10.5,9.8,10.5z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stxddasdasdasd23",
    d: "M8.3,13.5H3.8c-0.4,0-0.7,0.3-0.7,0.7S3.3,15,3.8,15h4.5C8.7,15,9,14.7,9,14.2S8.7,13.5,8.3,13.5z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stxddasdasdasd23",
    d: "M8.3,16.5H3.8c-0.4,0-0.7,0.3-0.7,0.7S3.3,18,3.8,18h4.5C8.7,18,9,17.7,9,17.2S8.7,16.5,8.3,16.5z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaktury, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faktury.569ea013.svg";
export { ForwardRef as ReactComponent };